import { defineMessages, type MessageDescriptor } from 'react-intl';

type MessageKeys =
	| 'allowSearchPastChatsLabel'
	| 'allowSearchPastChatsDescription'
	| 'allowSaveMemoriesLabel'
	| 'allowSaveMemoriesDescription'
	| 'learnMoreLabel'
	| 'manageMemoryButton';

export const messages: Record<MessageKeys, MessageDescriptor> = defineMessages({
	allowSearchPastChatsLabel: {
		id: 'ai-mate.rovo-memories.memory-management-settings.allow-search-past-chats.label',
		defaultMessage: 'Let Rovo reference past chats for better answers',
		description: 'Label for the toggle that allows Rovo to search and reference past chats',
	},
	allowSearchPastChatsDescription: {
		id: 'ai-mate.rovo-memories.memory-management-settings.allow-search-past-chats.description',
		defaultMessage:
			'When enabled, Rovo will reference earlier conversations to fill in missing context and better understand your reasoning.',
		description: 'Description for the allow search past chats setting',
	},
	allowSaveMemoriesLabel: {
		id: 'ai-mate.rovo-memories.memory-management-settings.allow-save-memories.label',
		defaultMessage: 'Memories',
		description: 'Label for the toggle that allows Rovo to save and update memories',
	},
	allowSaveMemoriesDescription: {
		id: 'ai-mate.rovo-memories.memory-management-settings.allow-save-memories.description',
		defaultMessage:
			'When enabled, Rovo saves facts you share about yourself—like your projects, preferences, or future goals—so it can personalize its answers to you. <a>Learn more about memory in Rovo</a>',
		description: 'Description for the allow save memories setting',
	},
	learnMoreLabel: {
		id: 'ai-mate.rovo-memories.memory-management-settings.learn-more.label',
		defaultMessage: 'Learn more about memory in Rovo',
		description: 'Link text below the settings; opens docs in new tab.',
	},
	manageMemoryButton: {
		id: 'ai-mate.rovo-memories.memory-management-settings.manage-memories-button',
		defaultMessage: 'Manage memories',
		description: 'Label used in the button to show manage memory subscreen',
	},
});
